import { useLocation, useNavigate } from "react-router-dom";
import { useT } from "@/lib/translation";
import { cn } from "@/lib/utils";
import { PieChart, BarChart3 } from "lucide-react";

interface ModeToggleProps {
  className?: string;
}

export const ModeToggle = ({ className }: ModeToggleProps) => {
  const t = useT();
  const location = useLocation();
  const navigate = useNavigate();

  const isAnalysis = location.pathname.startsWith("/analysis");
  const isPortfolio = location.pathname.startsWith("/portfolio");

  const btnBase =
    "flex-1 flex items-center justify-center gap-2 rounded-sm py-1.5 text-sm font-medium transition-all cursor-pointer select-none";

  return (
    <div className={cn("flex rounded-md bg-muted p-1", className)}>
      <button
        className={cn(
          btnBase,
          isPortfolio
            ? "bg-background text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground",
        )}
        onClick={() => navigate("/portfolio/dashboard")}
      >
        <PieChart className="h-3.5 w-3.5" />
        {t("nav:modeToggle.portfolio")}
      </button>
      <button
        className={cn(
          btnBase,
          isAnalysis
            ? "bg-background text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground",
        )}
        onClick={() => navigate("/analysis/stock-analysis")}
      >
        <BarChart3 className="h-3.5 w-3.5" />
        {t("nav:modeToggle.analysis")}
      </button>
    </div>
  );
};
